<nav>
  <!--Nav horizontal-->
  <div class="w-full flex align-content-between justify-content-center border-bottom-1">
    <div class="flex">
      <!--LOGO - APP-->
      <div class="p-4 navbar-logo">
        <button (click)="displayMenuOverlay()" class="text-3xl font-bold appearance-none">Cartanim</button>
      </div>
      <ul class="hidden sm:p-4 sm:flex sm:w-full">

      </ul>
    </div>
  </div>
</nav>
